// Re-export the new modular EditJobModal
export { default } from './edit-job/EditJobModal';